// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'bank-import.page.title': 'Imported Transactions',
    'bank-import.page.batch.title': 'Transaction Batch',
    'bank-import.page.search_results': 'Search Results',
    'bank-import.page.search.title': 'Find Transactions',
    'bank-import.page.view.title': 'View Transaction',
    'bank-import.page.import.title': 'Import Transactions',
    'bank-import.page.split.title': 'Split Transaction',
    'bank-import.page.all': 'All',

    'bank-import.button.cancel': 'Cancel',
    'bank-import.button.select': 'Select',
    'bank-import.button.find': 'Find Transactions',
    'bank-import.button.search': 'Apply',
    'bank-import.button.save': 'Save Changes',
    'bank-import.button.delete': 'Delete',
    'bank-import.button.empty': 'Delete Batch',
    'bank-import.button.reset': 'Reset',
    'bank-import.button.import': 'Import',
    'bank-import.button.upload': 'Upload',
    'bank-import.button.revert': 'Revert Reconciliation',
    'bank-import.button.download': 'Download sample file',
    'bank-import.button.split': 'Split Transaction',
    'bank-import.button.rollback_split': 'Rollback Split',
    'bank-import.button.add': 'Add Transaction',

    'bank-import.placeholder.search': 'Search transactions',

    'bank-import.link.create_first_bank_import': 'Click here to create your first transaction',
    'bank-import.link.bank_imports': ' Return to Transactions',
    'bank-import.link.bin': 'Binned Transactions',
    'bank-import.link.retry': 'Click here to retry',
    'bank-import.link.batch': 'View Batch',

    'bank-import.message.search.no_bank_import_batch': 'There are no transactions in this batch',
    'bank-import.message.no_transactions': 'No transactions imported as yet',
    'bank-import.message.zero_balance': 'Balance must be zero',

    'bank-import.checkbox.all': 'Check All',
    'bank-import.checkbox.actions_label': 'with selected',

    'bank-import.label.upload': 'Click to upload or drag and drop',
    'bank-import.label.upload_types': 'CSV',
    'bank-import.label.import_batch_no': 'Batch No',
    'bank-import.label.account_name': 'Bank Account',
    'bank-import.label.bank_transaction_type_name': 'Transaction Type',
    'bank-import.label.transaction_date': 'Transaction Date',
    'bank-import.label.reconciled_on': 'Reconciled On',
    'bank-import.label.cancelled_on': 'Cancelled On',
    'bank-import.label.description': 'Description',
    'bank-import.label.reference_code': 'Reference Code',
    'bank-import.label.memo': 'Memo',
    'bank-import.label.is_bundled': 'Is Bundled',
    'bank-import.label.currency_name': 'Currency',
    'bank-import.label.currency_amount_in_cents': 'Amount',
    'bank-import.label.original': 'Original Transaction',
    'bank-import.label.original_amount': 'Original Amount',

    'bank-import.label.is_reconciled': 'Is Reconciled',
    'bank-import.label.is_cancelled': 'Is Cancelled',
    'bank-import.label.cancellation_reason': 'Cancellation Reason',

    'bank-import.sort.field_label': 'Field',
    'bank-import.sort.direction_label': 'Direction',
    'bank-import.sort.direction_ascending': 'Ascending',
    'bank-import.sort.direction_descending': 'Descending',

    'bank-import.modal.title.bank_import_bin': 'Bin Transaction',
    'bank-import.modal.title.bank_import_revert': 'Revert Reconciliation',
    'bank-import.modal.title.bank_import_bin_empty': 'Delete All Transactions In Batch',
    'bank-import.modal.title.bank_import_delete_permanently': 'Delete Transaction',
    'bank-import.modal.title.bank_import_restore': 'Restore Transaction',

    'bank-import.modal.message.rollback_split': 'Are you sure to rollback split transactions?',
    'bank-import.modal.message.bank_import_bin': 'Are you sure that you want to move this transaction to the bin ? | Are you sure that you want to move these transactions to the bin ?',
    'bank-import.modal.message.bank_import_revert': 'Are you sure that you want to revert reconciliation of this transaction? | Are you sure that you want to revert reconciliation of these transactions?',
    'bank-import.modal.message.bank_import_bin_empty': 'Are you sure that you want to delete all transactions in this batch? This action cannot be undone!',
    'bank-import.modal.message.bank_import_delete_permanently':
        'Are you sure that you want to permanently delete this transaction? This action cannot be undone. | Are you sure that you want to permanently delete these transactions? This action cannot be undone.',
    'bank-import.modal.message.bank_import_restore': 'Are you sure that you want to restore this transaction? | Are you sure that you want to restore these transactions?',

    'bank-import.success.message.bank_import_uploaded': 'You will be notified via email when we complete processing your upload.',
    'bank-import.success.message.bank_import_created': 'Your transaction has been created',
    'bank-import.success.message.bank_import_updated': 'Your transaction has been updated',
    'bank-import.success.message.bank_import_restored': 'Your transaction has been restored | All selected transactions were restored',
    'bank-import.success.message.bank_import_deleted': 'Your transaction has been permanently deleted | All selected transactions were permanently deleted',
    'bank-import.success.message.bank_import_reverted': 'Your transaction has been reverted | All selected transactions were reverted',
    'bank-import.success.message.binned_bank_imports': 'Your transaction was moved to the bin | All selected transactions were moved to the bin',
    'bank-import.success.message.bank_import_bin_emptied': 'All transactions in batch were deleted!',
    'bank-import.success.message.bank_import_split': 'The transaction was successfully split.',
    'bank-import.success.message.rollback_split': 'The transaction split was successfully rolled back.',

    'bank-import.error.message.binned_bank_imports': 'This transaction was already deleted | These transactions were already delete',
    'bank-import.error.message.bank_import_bin_emptied': 'All transactions in batch were already deleted',
    'bank-import.error.message.bank_import_deleted': 'This transaction was already permanently deleted | These transactions were already permanently deleted',
    'bank-import.error.message.bank_import_reverted': 'This transaction was already reverted | These transactions were already reverted',
    'bank-import.error.message.bank_import_restored': 'This transaction was already restored | These transactions were already restored',
    'bank-import.error.message.error_loading_page': 'Sorry, there was an error loading transaction.| Sorry, there was an error loading transactions.',
};
